<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0">
          <strong>Excel Reports</strong>
        </h5>
      </div>
      <div class="card-body">
        <p class="text-muted mb-3">
          Download yearly Excel reports for auction data.
        </p>
        <a-list :data-source="years" :bordered="true">
          <a-list-item slot="renderItem" slot-scope="year">
            <a-list-item-meta>
              <template slot="title">
                <a-icon
                  type="file-excel"
                  style="color: #217346; margin-right: 8px;"
                />
                Auction Report {{ year }}
              </template>
              <template slot="description">
                Excel report for the year {{ year }}
              </template>
            </a-list-item-meta>
            <a-button
              type="primary"
              icon="download"
              :loading="downloadingYear === year"
              @click="downloadExcelReport(year)"
            >
              Download
            </a-button>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/api'

const MIN_DATE = 2023
const MAX_DATE = new Date().getFullYear()
const YEARS = []
for (let i = MAX_DATE; i >= MIN_DATE; i--) {
  YEARS.push(i)
}

export default {
  name: 'ExcelReports',
  data() {
    return {
      years: YEARS,
      downloadingYear: null,
    }
  },
  methods: {
    downloadExcelReport(year) {
      this.downloadingYear = year
      ApiService.downloadFile(
        `excel-report/${year}`,
        `auction-report-${year}.xlsx`
      )
        .catch(() => {})
        .finally(() => {
          this.downloadingYear = null
        })
    },
  },
}
</script>

<style scoped>
.text-muted {
  color: #999;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-3 {
  margin-bottom: 16px;
}
</style>
